module.exports = __webpack_public_path__ + "img/erro_x.760db5be.svg";